import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-delivery-truck-01-Stroke',
  standalone: true,
  templateUrl: '../../assets/delivery-truck-01/Stroke.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamDeliveryTruck01StrokeIcon {}
